import InitialPage from './Initial';

export default InitialPage;
